/<template>
    <b-card no-body class="card-challenges-header">
      <!-- <b-button :to="parent + '/sub/' + link"> -->
        
        <div class="header" :style="{'background-image': `url(${theMedia})`}">
            
            <div class="loadImg" :class="{hidden:hide}" :style="{'background-color': '#E1E5E8'}">
              <div class="img-logo">
                <img src="/img/logo-areas-B&W.png" height="100px" width="100px">
              </div>
            </div>

            <p class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='200px' height="40px">                              
                {{title}}
              </PuSkeleton>
            </p>
            <p class="subtitle">
              <PuSkeleton :loading="isLoading" :count="1" width='140px' height="20px">              
                {{subtitle}}
              </PuSkeleton>
            </p>
            <p class="subdate">
              <PuSkeleton :loading="isLoading" :count="1" width='260px'>              
                Du {{ startDate | moment(false) }} au {{ endDate | moment(true) }}
              </PuSkeleton>
            </p>
        </div>

          <b-button variant="link" class="footer" @click.prevent='onItemClick'>
              <div class="ranking">
                <div class="title">{{rankingTitle}}</div>
                <div class="bottom">
                  <PuSkeleton circle :loading="isLoading" :count="1" width="20px" height="20px">
                    <div class="target green">{{diff(previousRank,rank)}}</div>
                    <!-- <div class="target green" :class="diff(previousRank,rank)" >{{diff(previousRank,rank)}}</div> -->
                  </PuSkeleton>
                  <div class="rankingResult">
                    <PuSkeleton :loading="isLoading" :count="1" width="40px">                    
                      {{rankingResult}} 
                    </PuSkeleton>
                  </div>
                  <div class="rankingNumber">
                    <PuSkeleton :loading="isLoading" :count="1" width="20px">                    
                      / {{rankingNumber}}
                    </PuSkeleton>
                    </div>
                </div>
              </div>
              <div class="score">
                <div class="title">{{scoreTitle}}</div>
                <div class="number">
                  <PuSkeleton :loading="isLoading" :count="1" width="140px">                  
                    {{Math.round(scoreNumber).toLocaleString()}}
                  </PuSkeleton>
                </div>
              </div>
              <div class="link ">
                <font-awesome-icon :icon="['fal', 'arrow-right']"/>
              </div>
            </b-button>

    </b-card>
</template>


<script>
import Utils from '../../Utils';
import ApiService from '../../../services/ApiService'
import { mapGetters } from 'vuex'
import moment from 'moment'
moment.locale('fr');


//
export default {
  name: "CardChallengesHeader",
  components:{ 
  },
  computed: {
    ...mapGetters([
      'getChallengeSelected',
        'getIsMobile'
    ])
  },    
  props:{
    title:{
      type:String,
      default:'Title'
    },
    subtitle:{
      type:String,
      default:'Jeu concours'
    },
    startDate:{
      type:String,
      default:'01 FÉVRIER'
    },
    endDate:{
      type:String,
      default:'31 SEPTEMBRE 2020'
    },
    rankingTitle:{
      type:String,
      default:'Classement'
    },
    scoreTitle:{
      type:String,
      default:'Score'
    },
    ranking:{
      type:String,
      default:'Classement'
    },
    rankingNumber:{
      type:Number,
      default:1
    },
    rankingResult:{
      type:Number,
      default:4
    },    
    score:{
      type:String,
      default:'score'
    },
    scoreNumber:{
      type:Number,
      default:250
    },
    previousRank:{
      type:Number,
      default:0
    },
    rank:{
      type:Number,
      default:0
    },
    isLoad:{
      type:Boolean,
      default: true
    },
    img:{
      // type:Object,
      // default:'/img/challenges-img.png'
    }


  },
  data(){
    return {
      isLoading:true,
      isImageLoading:true,
      isMobile:false,
      theMedia:'',
      hide:false,
      item:{
        src:'/img/loader.png'
      },      
    }
  },
  created(){
    this.isLoading = this.isLoad;
    this.isMobile = this.getIsMobile;
    //
    this.getData();
  },

  methods:{
    async getData (){
      if(this.img){
        this.theMedia = await ApiService.getMediaApi().get(this.img);
        this.hide = true;
        this.isImageLoading = false;
      } else {
        this.isImageLoading = false;
      }
    },
    moment: function (date,year) {
      return moment(date,year);
    }, 
    diff: function(start,end){
      return Utils.compare(start,end);
    },
    onItemClick(){
      this.isMobile ? this.$router.push({ name: 'mobile', params: { subcat: 1 }}).catch(()=>{}) : this.$router.push({ name: 'challenges-classement'}).catch(()=>{});
    }
  },
  filters: {
    moment: function (date,year) {
      let $format = !year ? 'Do MMMM': 'Do MMMM YYYY';
      return moment(date).format($format);
    }
  },
  watch : {
    'isLoad' : function (){
      this.isLoading = this.isLoad;
      this.isImageLoading = this.isLoading;
      this.hide = false;
      this.getData();
    },
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  },      
}
</script>
